import { apiRequest, postApiRequest } from './_tools';


export function fetchApiStatuses({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/apiStatuses?page=${page}&itemsPerPage=${itemsPerPage}` +
    `&publisherId=${filter.publisherId}` +
    `&publisherName=${filter.publisherName}` +
    `&publisherEmail=${filter.publisherEmail}` +
    `&publisherWebsite=${filter.publisherWebsite}` +
    `&id=${filter.id}` +
    `&appId=${filter.appId}` +
    `&appName=${filter.appName}` +
    `&adType=${filter.adType}` +
    `&apiStatus=${filter.apiStatus}` +
    `&requestedFrom=${filter.requestedAt.from}` +
    `&requestedTo=${filter.requestedAt.to}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchApiStatusesAllCount() {
  return apiRequest('/api/apiStatusesAllCount')
    .catch(({ error }) => Promise.reject(error));
}

export function updateApiStatus({ placementId, appId, apiStatus }) {
  return postApiRequest(`/api/apiStatuses?appId=${appId}` +
    `&placementId=${placementId}` +
    `&apiStatus=${apiStatus}`)
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/apiStatuses.js
 **/